interface CustomToastProps {
	type: "Success" | "Error" | "Info" | "Warning";
	message: string;
}

const CustomToast = ({ type, message }: CustomToastProps) => {
	return (
		<div>
			<p className="text-base font-bold text-foreground">{type}</p>
			<p className="text-sm">{message}</p>
		</div>
	);
};

export default CustomToast;
